import type { NewsPublisherId } from '../constants/newsPublishers';
import { DEFAULT_RANKING_PROMPT } from './newsCursorRank';
import { DEFAULT_REDDIT_BLOCKLIST_PATTERNS } from './redditTitleFilter';

export type NewsFeedPreferences = {
  subreddits: string[];
  blocklistText: string;
  maxPostsPerSub: number;
  publishersEnabled: Record<NewsPublisherId, boolean>;
  maxPerPublisher: number;
  /** Plain-language instructions sent with headlines to Cursor for ranking. */
  rankingPrompt: string;
  maxRankedStories: number;
};

export const DEFAULT_NEWS_SUBREDDITS = ['worldnews', 'news', 'politics'] as const;

export function buildDefaultNewsFeedPreferences(): NewsFeedPreferences {
  return {
    subreddits: [...DEFAULT_NEWS_SUBREDDITS],
    blocklistText: DEFAULT_REDDIT_BLOCKLIST_PATTERNS.join('\n'),
    maxPostsPerSub: 12,
    publishersEnabled: {
      bbc: true,
      bbcmundo: true,
      guardian: true,
      elpais: true,
      hackernews: true,
    },
    maxPerPublisher: 10,
    rankingPrompt: DEFAULT_RANKING_PROMPT,
    maxRankedStories: 35,
  };
}
